import axios from "axios";

const BASE = "/api/fee-transaction";

export function create(data) {
  return axios.post(BASE, data);
}

export function getByRegistration(registrationId) {
  return axios.get(`${BASE}/by-registration/${registrationId}`);
}

export function update(id, data) {
  return axios.patch(`${BASE}/${id}`, data);
}

export function feePeriods(registrationId) {
  return axios.get(`${BASE}/registrations/${registrationId}/fee-periods`);
}

export function dismissProof(proofId, data = {}) {
  return axios.post(`${BASE}/proofs/${proofId}/dismiss`, data);
}

export function linkProof(proofId, data) {
  return axios.post(`${BASE}/proofs/${proofId}/link`, data);
}
